import * as React from "react";
import { observer } from "mobx-react-lite";
import {
    Dropdown,
    TextField,
    IDropdownOption,
    DialogFooter,
    PrimaryButton,
    DefaultButton,
    Checkbox,
    Stack,
    StackItem,
    IStackTokens,
} from "@fluentui/react";

import * as AddPlayerDialogController from "../../components/dialogs/AddPlayerDialogController";
import { IPlayer } from "../../state/TeamState";
import { AppState } from "../../state/AppState";
import { useAppState } from "../../contexts/StateContext";
import { ModalVisibilityStatus } from "../../state/ModalVisibilityStatus";
import { ModalDialog } from "./ModalDialog";

const dialogStackTokens: Partial<IStackTokens> = { childrenGap: 10 };

// TODO: Look into making a DefaultDialog, which handles the footers and default props
export const AddPlayerDialog = observer(function AddPlayerDialog(): JSX.Element {
    const appState: AppState = useAppState();

    return (
        <ModalDialog
            title="Add Player"
            visibilityStatus={ModalVisibilityStatus.AddPlayer}
            onDismiss={() => AddPlayerDialogController.hideDialog(appState)}
        >
            <AddPlayerDialogBody appState={appState} />
            <DialogFooter>
                <PrimaryButton
                    text="Add"
                    onClick={() => AddPlayerDialogController.addPlayer(appState)}
                    className="add-player-submit"
                />
                <DefaultButton text="Cancel" onClick={() => AddPlayerDialogController.hideDialog(appState)} />
            </DialogFooter>
        </ModalDialog>
    );
});

const AddPlayerDialogBody = observer(function AddPlayerDialogBody(props: IAddPlayerDialogBodyProps): JSX.Element {
    const appState: AppState = props.appState;

    const teamChangeHandler = (ev: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
        if (option?.text != undefined) {
            AddPlayerDialogController.changeTeamName(appState, option.text);
        }
    };

    const nameChangeHandler = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void =>
        AddPlayerDialogController.changePlayerName(appState, newValue ?? "");

    const addPlayerDialogState = appState.uiState.dialogState.addPlayerDialog;
    if (addPlayerDialogState === undefined) {
        return <></>;
    }

    const newPlayer: IPlayer = addPlayerDialogState.player;

    const teamOptions: IDropdownOption[] = appState.activeGame.teamNames.map((teamName, index) => {
        return {
            key: index,
            text: teamName,
            selected: newPlayer.teamName === teamName,
        };
    });

    return (
        <Stack tokens={dialogStackTokens}>
            <StackItem>
                <Dropdown className="add-player-team" label="Team" options={teamOptions} onChange={teamChangeHandler} />
            </StackItem>
            <StackItem>
                <TextField
                    inputClassName="add-player-name"
                    label="Name"
                    value={newPlayer.name}
                    required={true}
                    onChange={nameChangeHandler}
                    onGetErrorMessage={() => AddPlayerDialogController.validatePlayer(appState)}
                    validateOnFocusOut={true}
                    validateOnLoad={false}
                />
            </StackItem>
            <StackItem>
                <Checkbox
                    label="Add to active players"
                    checked={addPlayerDialogState.isActive}
                    onChange={(ev, checked) => AddPlayerDialogController.setIsActive(appState, checked ?? false)}
                />
            </StackItem>
        </Stack>
    );
});

interface IAddPlayerDialogBodyProps {
    appState: AppState;
}
